import router, { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

import { HistoryContext } from './HistoryContext'

export const HistoryProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { asPath, push, pathname } = useRouter()
  const [history, setHistory] = useState<string[]>([])

  function back(fallbackRoute?: string) {
    for (let i = history.length - 2; i >= 0; i--) {
      const route = history[i]
      if (
        !route.includes('#') &&
        !route.includes('search') &&
        route !== pathname
      ) {
        push(route)

        const newHistory = history.slice(0, i)
        setHistory(newHistory)

        return
      }
    }
    if (fallbackRoute) {
      router.push(fallbackRoute)
    }
  }

  useEffect(() => {
    setHistory((previous) => [...previous, asPath])
  }, [asPath])

  return (
    <HistoryContext.Provider
      value={{
        back,
        history,
        setHistory,
      }}
    >
      {children}
    </HistoryContext.Provider>
  )
}
